import { render } from "./HowItWorks.vue?vue&type=template&id=bf99f83c&scoped=true"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"

import "./HowItWorks.vue?vue&type=style&index=0&id=bf99f83c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf99f83c"]])

export default __exports__